import React from "react"
import {
  Backdrop,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Switch,
  Typography,
  useTheme,
} from "@mui/material"
import Image from "components/Image"
import UserAvatar from "components/User/UserAvatar"
import LogoutIcon from "@mui/icons-material/Logout"
import { APP_NAME } from "configs/AppConfig"
import { styles } from "./SidebarDrawer.styles"
import { useTranslation } from "react-i18next"

export const SidebarDrawerUI = ({
  currentRoute = "/",
  open = false,
  onClose = () => { },
  menuItems = [],
  userData = {},
  onMenuItemClick = () => { },
  onLogout = () => { },
  onChangeTutorialsPreference = () => { },
  onOpenExternalLink = () => { },
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const isActive = (path) => Boolean(path && currentRoute.startsWith(path))


  return (
    <>
      <Backdrop
        open={open}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer - 1,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        onClick={onClose}
      />
      <Drawer
        anchor="left"
        variant={open ? "permanent" : "temporary"}
        open={open}
        onClose={onClose}
        sx={styles.drawer}
      >
        <Stack sx={styles.sidebarContent}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            sx={styles.titleContent}
          >
            <Image name="logoAppBar" width={"45px"} height={"45px"} />
            <Typography variant="span" color={theme.palette.common.white}>
              {APP_NAME}
            </Typography>
          </Stack>
          <Stack sx={styles.menuContent}>
            <List sx={styles.menuList}>
              {menuItems.map(
                ({ label, icon, path, badge, externalLink }, index) => {
                  if (label === "")
                    return (
                      <Divider
                        sx={{ bgcolor: "#0f242c", my: "1rem" }}
                        key={index}
                      />
                    )
                  return (
                    <ListItem
                      key={index}
                      sx={[
                        styles.menuItem,
                        index === menuItems.length - 1 && styles.lastMenuItem,
                        isActive(path) && styles.activeMenuItem,
                      ]}
                      onClick={(evt) => {
                        evt.stopPropagation()
                        if (label === "Logout") {
                          onLogout()
                          return
                        }
                        if (externalLink?.length > 0) {
                          onOpenExternalLink(externalLink)
                        } else {
                          if (path && path.length > 0) {
                            onMenuItemClick(path)
                          }
                        }
                      }}
                    >
                      {label === "Tutorials" && (
                        <Box
                          sx={styles.tutorialSwitch}
                          onClickCapture={onChangeTutorialsPreference}
                        >
                          <Switch
                            checked={userData?.allowTutorials || false}
                            onChange={onChangeTutorialsPreference}
                            sx={styles.switch}
                          />
                        </Box>
                      )}
                      {badge !== undefined && (
                        <Box sx={styles.badge}>{badge}</Box>
                      )}
                      <ListItemText
                        primary={t(label)}
                        sx={styles.menuItemText}
                      />
                      <ListItemIcon
                        sx={[
                          styles.menuIcon,
                          isActive(path) && styles.activeMenuIcon,
                        ]}
                      >
                        {icon}
                      </ListItemIcon>
                    </ListItem>
                  )
                }
              )}
            </List>
          </Stack>
          <Stack sx={styles.accountContent}>
            <UserAvatar sx={styles.userAvatar} />
            <Stack sx={styles.accountDescription}>
              <Typography variant="span" sx={styles.accountName}>
                {`${userData?.name || ""} ${userData?.lastName || ""}`.trim()}
              </Typography>
              <Typography variant="span" sx={styles.accountUsername}>
                {userData?.username || ""}
              </Typography>
            </Stack>
            <IconButton
              sx={{
                flexShrink: 0,
              }}
              onClick={() => {
                onLogout()
              }}
            >
              <LogoutIcon sx={styles.logoutIcon} />
            </IconButton>
          </Stack>
        </Stack>
      </Drawer>
    </>
  )
}
